import { AuthService } from './../services/auth-service/auth.service';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
export namespace mainGuard {
  export const canActivate: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const cookieService=  inject(CookieService);
    if (authService.isAuthenticated()) {
      return true;
    } else {
      router.navigate(['/']);
      cookieService.deleteAll('/');
      localStorage.clear();
      return false;
    }
  };

  export const canActivateChild: CanActivateChildFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) => canActivate(route, state);
}
